import React from 'react';
import PropTypes from 'prop-types';

const NumberBadge = ({ number }) => (number ? <span className="label">{number}</span> : null);

NumberBadge.displayName = 'NumberBadge';

NumberBadge.propTypes = {
  number: PropTypes.number,
};

export default NumberBadge;
